import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    // Lock background scrolling when error occurs
    document.body.style.overflow = 'hidden';
    console.error("Unhandled Error Caught by MusB ErrorBoundary:", error, errorInfo);
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
  }

  handleReload = () => {
    document.body.style.overflow = '';
    window.location.reload();
  };

  handleGoHome = () => {
    document.body.style.overflow = '';
    window.location.href = '/';
  };


  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-overlay">
          <div className="error-boundary-backdrop" />
          <div className="error-boundary-modal glass fade-in">
            <div className="error-boundary-header">
              <div className="error-icon-badge">
                <AlertTriangle size={36} className="error-icon" />
              </div>
              <h2>Something Went Wrong</h2>
              <p className="error-subtitle">
                We ran into an unexpected issue while loading this page. Don't worry, your cart and information are completely safe.
              </p>
            </div>

            <div className="error-boundary-actions">
              <button onClick={this.handleReload} className="btn-error-primary">
                <RefreshCw size={18} /> Reload Page
              </button>
              <button onClick={this.handleGoHome} className="btn-error-secondary">
                <Home size={18} /> Go to Homepage
              </button>
            </div>


          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
